import React from 'react'
import { useEffect, useState } from 'react'
import Page from '../../../components/page/page'
import { CustomIframe } from '../../../components/shared/customIframe/customIframe'
import { getActiveBalanceZone, getActiveCompany, getCustomerDomain } from '../../../redux'

export interface ConsultationPageProps {}

export const ConsultationPage: React.FC<ConsultationPageProps> = props => {
  const apiSuffixUrl = 'https://' + getCustomerDomain()
  // const apiSuffixUrl = 'https://localhost:44394';
  let activeCompany = getActiveCompany()
  let activeBalanceZone = getActiveBalanceZone()
  const [routeLocal, setRouteLocal] = useState(`${apiSuffixUrl}/trades/consulta`)

  useEffect(() => {
    call()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCompany, activeBalanceZone])

  const call = async () => {
    setRouteLocal(
      `${apiSuffixUrl}/company/index/${activeCompany?.id}?idBalanceZone=${activeBalanceZone?.id}&company=${activeCompany?.description}&balanceZoneDescription=${activeBalanceZone?.description}`
    )

    setTimeout(() => {
      setRouteLocal(`${apiSuffixUrl}/trades/consulta`)
    }, 1000)
  }

  return (
    <Page>
      <CustomIframe
        route={decodeURI(routeLocal)}
        width="100%"
        height="1200"
        allowFullScreen={true}
      />
    </Page>
  )
}
